import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { tBillPayModel } from 'src/app/models/tBillPayModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tBillPayService } from 'src/app/services/tBillPay.service';

@Component({
  selector: 'app-bill-payment-prescription-update-dialog',
  templateUrl: './bill-payment-prescription-update-dialog.component.html',
  styleUrls: ['./bill-payment-prescription-update-dialog.component.css']
})
export class BillPaymentPrescriptionUpdateDialogComponent implements OnInit {

  @Input() msg: string;
  @Input() billPayPrescriptionList: tBillPayModel[];
  @Input() invoiceID: string;

  isLoading: boolean = true;


  private serverBillPayData: tBillPayModel[] = new Array;

  public TAG: string = "BillPaymentPrescriptionUpdateDialogComponent";
  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private billPayService: tBillPayService
  ) { }

  ngOnInit() {
    this.getServerBillPayData();
  }


  getServerBillPayData() {
    this.log.i(this.TAG, "do getServerBillPayData invoiceID = " + this.invoiceID);

    this.isLoading = true;
    var shopID = NavigationComponent.selectedShopID.toString();

    this.billPayService.getDataByShopIDAndVoucherID(shopID, this.invoiceID).subscribe(data => {

      this.serverBillPayData = data;
      this.isLoading = false;

    },
      error => {
        this.isLoading = false;

      });
  }



  confirm() {
    this.log.i(this.TAG, "do confirm");
  }


  cancel() {
    this.log.i(this.TAG, "do cancel");
  }

  updateRow(data: tBillPayModel) {
    this.log.d(this.TAG, "do updateRow");
    //  this.activeModal.close(data);
    this.isLoading = true;

    //update data
    this.billPayService.UpdatePrescriptionPrice(data.shopID, data.bpConsultNumber, data.bpRemark, data.id.toString())
      .subscribe(
        (data: tBillPayModel) => {
          this.log.i(this.TAG, 'onSubmit update success');
          this.getServerBillPayData();
          this.isLoading = false;

        },
        err => {
          this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
          this.isLoading = false;

        });


  }

  getServerAmount(data: tBillPayModel): string {
    var model = this.serverBillPayData.find(p => p.id == data.id);
    var msg = "";

    if (model != null) {
      msg = model.bpArAmount.toString();
    }

    return "$" + msg;
  }
}
